import mockAxios, { AxiosResponse } from 'axios';
import { IItemServiceMock } from './item.mock.types';

export const mockItemService = (): IItemServiceMock => ({
  exportItems: jest.fn(),
  fetchItems: jest.fn(),
  fetchItem: jest.fn(),
  createItem: jest.fn(),
  updateItem: jest.fn(),
  deleteItem: jest.fn(),
  uploadItemFile: jest.fn()
});

export const mockItemAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
